// import { createContext, useState, useEffect } from "react";
// import homePageAPI from "../api/homePageApi";

// export const CategoryContext = createContext();

// const CACHE_KEY = "categories_cache";
// const CACHE_TIME = 60 * 60 * 1000; // 1 hour

// export const CategoryProvider = ({ children }) => {
//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const cachedData = localStorage.getItem(CACHE_KEY);

//       if (cachedData) {
//         const { data, timestamp } = JSON.parse(cachedData);

//         if (Date.now() - timestamp < CACHE_TIME) {
//           setCategories(data);
//           return;
//         }
//       }

//       const res = await homePageAPI.fetchCategories();

//       if (res.code === 200) {
//         setCategories(res.data);

//         localStorage.setItem(
//           CACHE_KEY,
//           JSON.stringify({
//             data: res.data,
//             timestamp: Date.now(),
//           }),
//         );
//       }
//     } catch (err) {
//       console.log("No Data");
//     }
//   };

//   return (
//     <CategoryContext.Provider value={{ categories }}>
//       {children}
//     </CategoryContext.Provider>
//   );
// };

import { createContext, useState, useEffect } from "react";
import homePageAPI from "../api/homePageApi";

export const CategoryContext = createContext();

const CACHE_KEY = "categories_cache";
const CACHE_TIME = 60 * 60 * 1000; // 1 hour

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);

        if (Date.now() - timestamp < CACHE_TIME) {
          setCategories(data);
          return;
        }
      }

      const res = await homePageAPI.fetchCategories();

      if (res.code === 200) {
        setCategories(res.data);

        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            data: res.data,
            timestamp: Date.now(),
          }),
        );
      }
    } catch (err) {
      console.log("No Data");
    }
  };

  return (
    <CategoryContext.Provider value={{ categories }}>
      {children}
    </CategoryContext.Provider>
  );
};
